import text from '../text.json'

export const formatPragueDistricts = (district: string) => {
    const formattedDistrict =
        text.districts[district as keyof typeof text.districts]

    return formattedDistrict ? formattedDistrict : district
}
